"use client";
import { GIFS } from "@/lib/constants";
import { Stack, Typography, useTheme } from "@mui/material";
import Image from "next/image";
import { useState } from "react";
import { motion } from "framer-motion";

function HeroLoaderComponent({
  open,
  loadingLabel = "Please wait while page is loading...",
  poweredBy = "Powered By",
  imgSrc = "",
}) {
  const theme = useTheme();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  const pulseAnimation = {
    scale: [1, 1.3, 1],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut",
    },
  };
  return (
    <div
      style={{
        position: "fixed",
        height: `100vh`,
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f2f7f7",
        overflow: "hidden",
        borderRadius: "16px",
        zIndex: "9999999",
        top: 0,
        left: 0,
      }}
    >
      <Stack justifyContent="center" alignItems="center" spacing={1} px={2}>
        <Image src={GIFS.loader} height={200} width={200} alt="loader" />

        <Typography align="center" variant="h6" color="BLACK" gutterBottom>
          {loadingLabel}
        </Typography>

        <div className="footer">
          <p>
            {poweredBy}{" "}
            <strong>
              <Image src={imgSrc} alt="Logo" />
            </strong>
          </p>
        </div>
      </Stack>
      {/* Left side pulse */}
      <motion.div
        animate={pulseAnimation}
        style={{
          position: "absolute",
          left: 0,
          top: "40%",
          bottom: 0,
          width: "25px",
          height: "100px",
          background: "#47ee40",
          clipPath: "polygon(0 0, 70% 10%, 70% 90%, 0 100%)",
        }}
      />

      {/* Right side pulse */}
      <motion.div
        animate={pulseAnimation}
        style={{
          position: "absolute",
          right: 0,
          top: "40%",
          bottom: 0,
          width: "25px",
          height: "100px",
          background: "#47ee40",
          clipPath: "polygon(30% 10%, 100% 0, 100% 100%, 30% 90%)",
        }}
      />
    </div>
  );
}

export default HeroLoaderComponent;
